import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import fieldsValidator from 'library/helpers/validators/fieldsValidator';
import React, { useEffect, useState } from 'react';
import { Input, Tooltip } from 'zui/Antd';

const RenderCredential = ({ setting, settings, index, setSettings, canEditSettings }) => {
	const [form] = Form.useForm();
	const [options, setOptions] = useState([]);
	const [passwordVisible, setPasswordVisible] = useState(false);

	useEffect(() => {
		setOptions(
			setting.value || [
				{ name: 'userName', value: '' },
				{ name: 'password', value: '' }
			]
		);
	}, [setting]);

	useEffect(() => {
		const fieldsValue = options.reduce((acc, option) => {
			acc[option.name] = option.value;
			return acc;
		}, {});
		form.setFieldsValue(fieldsValue);
	}, [options, form]);

	const onValuesChange = (changedValues, allValues) => {
		const allLabelsFilled = Object.keys(allValues).every((field) => field.trim() !== '');

		const enrichArrayWithValues = (obj, arr) => {
			return arr.map((item) => ({
				...item,
				value: obj[item.name]
			}));
		};

		const finalValue = enrichArrayWithValues(allValues, options);

		const updatedSettings = [...settings];
		updatedSettings[index] = {
			...setting,
			value: allLabelsFilled ? finalValue : null
		};
		setSettings(updatedSettings);
	};

	return (
		<Tooltip title={!canEditSettings ? "You don't have permission to edit settings" : ''}>
			<Form form={form} onValuesChange={onValuesChange} style={{ width: '100%' }}>
				<Form.Item name={'userName'} rules={fieldsValidator.String} label={'Account Email'}>
					<Input placeholder='User Email' className='fieldString' disabled={!canEditSettings} />
				</Form.Item>
				<Form.Item name={'password'} rules={fieldsValidator.String} label={'Password'}>
					<Input
						placeholder='Account Password'
						className='fieldString'
						type={passwordVisible ? 'text' : 'password'}
						suffix={
							<div
								title='Show Password'
								onClick={() => setPasswordVisible(!passwordVisible)}
								style={{ cursor: 'pointer' }}
							>
								{passwordVisible ? <EyeOutlined /> : <EyeInvisibleOutlined />}
							</div>
						}
						disabled={!canEditSettings}
					/>
				</Form.Item>
			</Form>
		</Tooltip>
	);
};

export default RenderCredential;
